import React from 'react';

import {
  Grid,
  Typography
} from 'e100-react-components';
import { Box } from 'shared/components';

import { useFavouriteBrands } from 'entities/brands';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';

export const EmptyItemsMessage = () => {
  const { formatMessage } = useIntl();
  const favouriteBrands = useFavouriteBrands() || [];
  const classes = useStyles();

  if (favouriteBrands.length) {
    return null;
  }

  return (
    <Box
      padding={{
        left: 2.75,
        right: 2.75
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography
            color="secondary"
            variant="subtitle2"
            classes={{
              root: classes.title
            }}
          >
            {formatMessage({ id: 'favouriteStations.emptyItems.warningTitle' })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            color="secondary"
            variant="caption"
          >
            {formatMessage({ id: 'favouriteStations.emptyItems.warningMessage' })}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
